import { combineReducers } from 'redux';
import app from '../components/app';
import users from '../components/users';
import drive from '../components/drive';
import group from '../components/group';
import cap17drive from '../components/cap17drive'

const rootReducer = combineReducers({
    app: app.reducer,
    users: users.reducer,
    drive: drive.reducer,
    groups: group.reducer,
    cap17drive: cap17drive.reducer
});

export default rootReducer;
